import {
	createRouter,
	// createWebHistory
	createWebHashHistory
} from "vue-router";

const routes = [{
		path: '/',
		redirect: '/index'
	}, {
		path: '/index',
		name: 'index',
		component: () => import('@/views/index/index.vue'),
		meta: {
			title: '首页'
		}
	}, {
		path: '/demo',
		name: 'demo',
		component: () => import('@/views/demo.vue'),
		meta: {
			title: '首页'
		}
	},
	{
		path: '/member',
		name: 'member',
		component: () => import('@/components/member/Index.vue'),
		meta: {
			title: '会员中心',
			isLogin: false
		},
		children: [{
				path: 'index',
				name: 'member_center',
				component: () => import('@/views/member/index.vue'),
				meta: {
					title: '会员中心',
					isLogin: false
				}
			}, {
				path: 'notice',
				name: 'member_notice',
				component: () => import('@/views/member/notice/index.vue'),
				meta: {
					title: '会员中心',
					isLogin: false
				}
			}, {
				path: 'safe',
				name: 'member_safe',
				component: () => import('@/views/member/safe/index.vue'),
				meta: {
					title: '会员中心',
					isLogin: false
				}
			}, {
				path: 'order',
				name: 'member_order',
				component: () => import('@/views/member/order/index.vue'),
				meta: {
					title: '商品订单',
					isLogin: false
				}
			}, {
				path: 'odetail/:order_no',
				name: 'member_odetail',
				component: () => import('@/views/member/order/detail.vue'),
				meta: {
					title: '订单详情',
					isLogin: false
				}
			}, {
				path: 'insurance',
				name: 'member_insurance',
				component: () => import('@/views/member/insurance/index.vue'),
				meta: {
					title: '我申请的保险',
					isLogin: false
				}
			}, {
				path: 'loan',
				name: 'member_loan',
				component: () => import('@/views/member/loan/index.vue'),
				meta: {
					title: '我申请的贷款',
					isLogin: false
				}
			}, {
				path: 'history',
				name: 'member_history',
				component: () => import('@/views/member/bidding/history.vue'),
				meta: {
					title: '报名竞价项目',
					isLogin: false
				}
			}, {
				path: 'signup',
				name: 'member_signup',
				component: () => import('@/views/member/bidding/signup.vue'),
				meta: {
					title: '历史竞价项目',
					isLogin: false
				}
			}, {
				path: 'win',
				name: 'member_win',
				component: () => import('@/views/member/bidding/win.vue'),
				meta: {
					title: '我中标的项目',
					isLogin: false
				}
			}, {
				path: 'release/:type',
				name: 'member_release',
				component: () => import('@/views/member/release/index.vue'),
				meta: {
					title: '我中标的项目',
					isLogin: false,
					keepalive: false
				}
			}, {
				path: 'zjconsult',
				name: 'member_zj_consult',
				component: () => import('@/views/member/zhuanjia/consult/zjconsult.vue'),
				meta: {
					title: '咨询列表',
					isLogin: false
				}
			}, {
				path: 'consult',
				name: 'member_consult',
				component: () => import('@/views/member/zhuanjia/consult/index.vue'),
				meta: {
					title: '咨询列表',
					isLogin: false
				}
			}, {
				path: 'collect',
				name: 'member_collect',
				component: () => import('@/views/member/collect/index.vue'),
				meta: {
					title: '咨询列表',
					isLogin: false
				}
			}, {
				path: 'pnongzi',
				name: 'member_pnongzi',
				component: () => import('@/views/member/xzfw/nongzi.vue'),
				meta: {
					title: '农资服务管理',
					isLogin: true
				}
			}, {
				path: 'pnongji',
				name: 'member_pnongji',
				component: () => import('@/views/member/xzfw/nongji.vue'),
				meta: {
					title: '农机服务管理',
					isLogin: true
				}
			}, {
				path: 'onongzi',
				name: 'member_onongzi',
				component: () => import('@/views/member/xzfw/onongzi.vue'),
				meta: {
					title: '农资订单管理',
					isLogin: true
				}
			}, {
				path: 'product',
				name: 'member_product',
				component: () => import('@/views/member/sell/product.vue'),
				meta: {
					title: '农产品管理',
					isLogin: true
				}
			}, {
				path: 'sorder',
				name: 'member_sorder',
				component: () => import('@/views/member/sell/order.vue'),
				meta: {
					title: '农产品订单管理',
					isLogin: true
				}
			}, {
				path: 'onongji',
				name: 'member_onongji',
				component: () => import('@/views/member/xzfw/onongji.vue'),
				meta: {
					title: '农机订单管理',
					isLogin: true
				}
			}, {
				path: 'pdetail/:code',
				name: 'member_pdetail',
				component: () => import('@/views/member/xzfw/pdetail.vue'),
				meta: {
					title: '咨询列表',
					isLogin: false
				}
			}


		]
	},

	{
		path: '/public/pay',
		name: 'public_pay',
		component: () => import('@/views/public/pay.vue'),
		meta: {
			title: '在线支付',
			isLogin: true
		}
	}, {
		path: '/nongzi',
		name: 'nongzi',
		component: () => import('@/views/nongzi/index.vue'),
		meta: {
			title: '农资服务',
			isLogin: false
		}
	}, {
		path: '/nongzi/detail/:code',
		name: 'public_detail',
		component: () => import('@/views/nongzi/detail.vue'),
		meta: {
			title: '农业服务详情',
			isLogin: false
		}
	}, {
		path: '/public/pdetail/:id',
		name: 'public_pdetail',
		component: () => import('@/views/public/pdetail.vue'),
		meta: {
			title: '农业服务详情',
			isLogin: false
		}
	}, {
		path: '/public/order',
		name: 'public_order',
		component: () => import('@/views/public/order.vue'),
		meta: {
			title: '农业服务详情',
			isLogin: false
		}
	}, {
		path: '/nongzi/signup/:code',
		name: 'nongzi_signup',
		component: () => import('@/views/nongzi/signup.vue'),
		meta: {
			title: '我要报名',
			isLogin: false
		}
	}, {
		path: '/nongzi/gongshi/:rid',
		name: 'nongzi_gongshi',
		component: () => import('@/views/nongzi/gongshi.vue'),
		meta: {
			title: '我要报名',
			isLogin: false
		}
	}, {
		path: '/nongzi/gongshi/detail/:id',
		name: 'nongzi_gongshi_detail',
		component: () => import('@/views/nongzi/gongshi_detail.vue'),
		meta: {
			title: '我要报名',
			isLogin: false
		}
	},{
		path: '/agriculture/gonggao/:id',
		name: 'agriculture_gonggao',
		component: () => import('@/views/agriculture/gonggao.vue'),
		meta: {
			title: '中心公告',
			isLogin: false
		}
	},

	{
		path: '/nongji',
		name: 'nongji',
		component: () => import('@/views/nongji/index.vue'),
		meta: {
			title: '农资服务',
			isLogin: false
		}
	}, {
		path: '/nongji/detail/:code',
		name: 'nongji_detail',
		component: () => import('@/views/nongji/detail.vue'),
		meta: {
			title: '农业服务详情',
			isLogin: false
		}
	}, {
		path: '/nongji/pdetail/:id',
		name: 'nongji_pdetail',
		component: () => import('@/views/nongji/pdetail.vue'),
		meta: {
			title: '农业服务详情',
			isLogin: false
		}
	}, {
		path: '/nongji/signup/:code',
		name: 'nongji_signup',
		component: () => import('@/views/nongji/signup.vue'),
		meta: {
			title: '我要报名',
			isLogin: false
		}
	}, {
		path: '/nongji/gongshi/:rid',
		name: 'nongji_gongshi',
		component: () => import('@/views/nongji/gongshi.vue'),
		meta: {
			title: '我要报名',
			isLogin: false
		}
	}, {
		path: '/nongji/gongshi/detail/:id',
		name: 'nongji_gongshi_detail',
		component: () => import('@/views/nongji/gongshi_detail.vue'),
		meta: {
			title: '我要报名',
			isLogin: false
		}
	}, {
		path: '/talent',
		name: 'talent',
		component: () => import('@/views/talent/index.vue'),
		meta: {
			title: '人才服务',
			isLogin: false
		}
	}, {
		path: '/financial',
		name: 'financial',
		component: () => import('@/views/financial/index.vue'),
		meta: {
			title: '金融服务',
			isLogin: false
		}
	}, {
		path: '/financial/detail/:id',
		name: 'financial_detail',
		component: () => import('@/views/financial/detail.vue'),
		meta: {
			title: '金融服务',
			isLogin: false
		}
	}, {
		path: '/news',
		name: 'news',
		component: () => import('@/views/news/index.vue'),
		meta: {
			title: '金融服务',
			isLogin: false
		}
	}, {
		path: '/news/detail/:id',
		name: 'news_detail',
		component: () => import('@/views/news/detail.vue'),
		meta: {
			title: '金融服务',
			isLogin: false
		}
	}, {
		path: '/products',
		name: 'products',
		component: () => import('@/views/products/index.vue'),
		meta: {
			title: '电商服务',
			isLogin: false
		}
	}, {
		path: '/products/detail/:id',
		name: 'products_detal',
		component: () => import('@/views/products/detail.vue'),
		meta: {
			title: '电商服务',
			isLogin: false
		}
	}, {
		path: '/products/list',
		name: 'products_list',
		component: () => import('@/views/products/list.vue'),
		meta: {
			title: '农产品列表',
			isLogin: false
		}
	}, {
		path: '/products/news/list',
		name: 'products_news',
		component: () => import('@/views/products/news/list.vue'),
		meta: {
			title: '粮油作物列表',
			isLogin: false
		}
	}, {
		path: '/products/news/detail/:id',
		name: 'products_news_detail',
		component: () => import('@/views/products/news/detail.vue'),
		meta: {
			title: '粮油作物详情',
			isLogin: false
		}
	},
	{
		path: '/feature',
		name: 'feature',
		component: () => import('@/views/feature/index.vue'),
		meta: {
			title: '电商服务',
			isLogin: false
		}
	}, {
		path: '/feature/detail/:id',
		name: 'feature_detal',
		component: () => import('@/views/feature/detail.vue'),
		meta: {
			title: '电商服务',
			isLogin: false
		}
	},
	{
		path: '/distributor',
		name: 'distributor',
		component: () => import('@/views/distributor/index.vue'),
		meta: {
			title: '招商服务',
			isLogin: false
		}
	}, {
		path: '/distributor/detail/:id',
		name: 'distributor_detail',
		component: () => import('@/views/distributor/detail.vue'),
		meta: {
			title: '招商服务',
			isLogin: false
		}
	}, {
		path: '/policy',
		name: 'policy',
		component: () => import('@/views/policy/index.vue'),
		meta: {
			title: '农业政策',
			isLogin: false
		}
	}, {
		path: '/policy/detail/:id',
		name: 'policy_detail',
		component: () => import('@/views/policy/detail.vue'),
		meta: {
			title: '农业政策详情',
			isLogin: false
		}
	}, {
		path: '/modern',
		name: 'modern',
		component: () => import('@/views/modern/index.vue'),
		meta: {
			title: '现代都市农业',
			isLogin: false
		}
	}, {
		path: '/modern/detail/:id',
		name: 'modern_detail',
		component: () => import('@/views/modern/detail.vue'),
		meta: {
			title: '现代都市农业',
			isLogin: false
		}
	}, {
		path: '/cooperative',
		name: 'cooperative',
		component: () => import('@/views/cooperative/index.vue'),
		meta: {
			title: '党支部领办合作社',
			isLogin: false
		}
	}, {
		path: '/cooperative/detail/:id',
		name: 'cooperative_detal',
		component: () => import('@/views/cooperative/detail.vue'),
		meta: {
			title: '党支部领办合作社-详情',
			isLogin: false
		}
	},
	{
		path: '/aboutus',
		name: 'aboutus',
		component: () => import('@/views/aboutus.vue'),
		meta: {
			title: '关于我们',
			isLogin: false
		}
	}, {
		path: '/settled',
		name: 'settled',
		component: () => import('@/views/settled.vue'),
		meta: {
			title: '入驻单位',
			isLogin: false
		}
	},
	{
		path: '/consult',
		name: 'consult',
		component: () => import('@/views/consult/index.vue'),
		meta: {
			title: '我要咨询',
			isLogin: false
		}
	},
	{
		path: '/bidding',
		name: 'bidding',
		component: () => import('@/views/bidding/index.vue'),
		meta: {
			title: '竞价中心',
			isLogin: false
		}
	}, {
		path: '/login/:type',
		name: 'login',
		component: () => import('@/views/login/index.vue'),
		meta: {
			title: '登录方式',
			isLogin: false
		}
	}
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title + '-高阳县数字农业平台'
	} else {
		document.title = '高阳县数字农业平台'
	}

	// to要跳转到的路径
	// from从哪个路径来
	// next往下执行的回调
	// 在localStorage中获取token
	let userInfo = localStorage.getItem('GAOYANGNONGYE_PC_USERINFO')
	let userId = localStorage.getItem('GAOYANGNONGYE_PC_USERID')
	let token = localStorage.getItem('GAOYANGNONGYE_PC_ACCESS_TOKEN')
	// console.log(userInfo, userId, token)

	// 判断该页面是否需要登录
	if (to.meta.isLogin) {
		// 如果token存在直接跳转
		if (userInfo && userId && token) {
			next()
		} else {
			// 否则跳转到login登录页面
			next({
				path: '/login',
				// 跳转时传递参数到登录页面，以便登录后可以跳转到对应页面
				query: {
					redirect: to.fullPath
				}
			})
		}
	} else {
		// 如果不需要登录，则直接跳转到对应页面
		next()
	}
})

export default router;